/* =========================
   Cart Drawer (FULL FILE)
   - Fix: drawer opens from URL ?openCartDrawer=true
   - Fix: subscription change waits for line ids, never sends invalid updates
   - Fix: loader always turns off
   - Fix: GraphQL cart query includes sellingPlanAllocation
   ========================= */

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartToken = null;
    this.lineItems = [];
    this._subscriptionRetryCount = 0;
    this._maxSubscriptionRetries = 15;

    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());

    const overlay = this.querySelector("#CartDrawer-Overlay");
    if (overlay) overlay.addEventListener("click", this.close.bind(this));

    this.bindUIElements();

    this.setHeaderCartIconAccessibility();
    this.setHeaderCartIconsAccessibility();
    toggleProgressBarVisibilityOnUpdate();

    this.initCartSession();
  }

  async initCartSession() {
    // Ensure cart token is loaded before getting cart line ids
    await this.getCartToken();
    await this.getCartLineIds();
  }

  bindUIElements() {
    this.purchaseOptions = this.querySelector("#selling-plan-options");
    console.log("Inside bindUIElements()");

    // IMPORTANT: keep the same handler reference so removeEventListener works
    if (!this._onSubscriptionChangedBound) {
      this._onSubscriptionChangedBound = this.onSubscriptionChanged.bind(this);
    }

    if (this.purchaseOptions) {
      this.purchaseOptions.removeEventListener("change", this._onSubscriptionChangedBound);
      this.purchaseOptions.addEventListener("change", this._onSubscriptionChangedBound);
    }
  }

  toggleCartDrawerLoader(forceState) {
    const cartDrawerLoader = this.querySelector(".cart-drawer-loader");
    if (!cartDrawerLoader) return;

    // forceState: true = show, false = hide, undefined = toggle
    if (typeof forceState === "boolean") {
      cartDrawerLoader.classList.toggle("hidden", !forceState);
      return;
    }

    cartDrawerLoader.classList.toggle("hidden");
  }

syncDeliveryFrequencyUI() {
  const mealItems = Array.from(this.querySelectorAll('.cart-item.--item-is-meal'));

  if (!mealItems.length) return;

  // Delivery frequency UI is global (one set of radios)
  const fieldset = this.querySelector('#selling-plan-options');
  if (!fieldset) return;

  const radios = Array.from(
    fieldset.querySelectorAll('input[type="radio"][name="purchase_option"]')
  );

  // Clear all radios first
  radios.forEach(radio => {
    radio.checked = false;
  });

  // Use first meal item as source of truth
  const item = mealItems[0];
  const lineId = item.getAttribute('data-line-id');
  const line = this.lineItems.find(l => l.id === lineId);
  if (!line) return;

  const planContainer = item.querySelector('.selling-plan-options');
  if (!planContainer) return;

  const oneWeekId = planContainer.getAttribute('data-selling-plan-1-week-id');
  const twoWeekId = planContainer.getAttribute('data-selling-plan-2-weeks-id');

  // ONE-OFF
  if (!line.sellingPlanId) {
    const oneOffRadio = fieldset.querySelector('input[value=""]');
    if (oneOffRadio) oneOffRadio.checked = true;
    return;
  }

  // WEEKLY
  if (line.sellingPlanId === oneWeekId) {
    const weeklyRadio = fieldset.querySelector(
      'input[value="Delivery every 1 Week"]'
    );
    if (weeklyRadio) weeklyRadio.checked = true;
  }

  // FORTNIGHTLY
  if (line.sellingPlanId === twoWeekId) {
    const fortnightlyRadio = fieldset.querySelector(
      'input[value="Delivery every 2 Weeks"]'
    );
    if (fortnightlyRadio) fortnightlyRadio.checked = true;
  }
}


async onSubscriptionChanged(e) {
  // console.log("In onSubscriptionChanged()");
  const selectedValue = e?.target?.value;
  console.log("In onSubscriptionChanged() SelectedValue: ", selectedValue);
  // Allow One-off (empty value), block only undefined/null
  if (selectedValue === undefined || selectedValue === null) {
    return;
  }
  let response;
  // Wait until cart line IDs exist
  const mealLineItems = Array.from(this.querySelectorAll('.cart-item.--item-is-meal'));
  console.log("In onSubscriptionChanged() MealLineItems: ", mealLineItems);
  const hasMissingLineIds = mealLineItems.some(item => !item.getAttribute('data-line-id'));
  console.log("In onSubscriptionChanged() LineItemsLength: ", this.lineItems?.length);
  console.log("In onSubscriptionChanged() HasMissingLineIds: ", hasMissingLineIds);

  if (!this.lineItems?.length || hasMissingLineIds) {
    console.log("In onSubscriptionChanged() inside if");
    setTimeout(() => this.onSubscriptionChanged(e), 150);
    return;
  }

  this.toggleCartDrawerLoader(true);

  try {
    const mealPlanLinesForUpdate = mealLineItems
      .map((mealLineItem) => {
        const lineId = mealLineItem.getAttribute('data-line-id');
        console.log('LineId: ', lineId);
        if (!lineId) return null;

        const planContainer = mealLineItem.querySelector('.selling-plan-options');
        if (!planContainer) return null;

        let sellingPlanId = null;

        console.log('SelectedValue: ', selectedValue);
        if (selectedValue === 'Delivery every 1 Week') {
          sellingPlanId = planContainer.getAttribute('data-selling-plan-1-week-id');
        }

        if (selectedValue === 'Delivery every 2 Weeks') {
          sellingPlanId = planContainer.getAttribute('data-selling-plan-2-weeks-id');
        }

        if (selectedValue === '') {
          sellingPlanId = null;
        }

        // If user chose subscription but no plan ID exists, do not touch this line
       if (selectedValue !== '' && !sellingPlanId) {
          console.warn(
            'Missing selling plan ID for',
            selectedValue,
            '— skipping line'
          );
          return null;
        }

        return {
          lineId,
          sellingPlanId
        };
      })
      .filter(Boolean);

    console.log(
      'cdebug selectedValue and mealPlanLinesForUpdate',
      selectedValue,
      mealPlanLinesForUpdate
    );

    if (!mealPlanLinesForUpdate.length) {
      console.warn('No valid meal lines to update. Aborting cartLinesUpdate.');
      return;
    }

    const cartMutation = `
      mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
        cartLinesUpdate(cartId: $cartId, lines: $lines) {
          cart { id }
          userErrors { field message }
        }
      }
    `;

    const mutationVariables = {
      cartId: `gid://shopify/Cart/${this.cartToken}`,
      lines: mealPlanLinesForUpdate.map(line => ({
        id: line.lineId,
        sellingPlanId: line.sellingPlanId
          ? `gid://shopify/SellingPlan/${line.sellingPlanId}`
          : null
      }))
    };

    response = await window.storeFrontAPIClient.request(cartMutation, {
      variables: mutationVariables
    });

    console.log('cdebug cart gql', response);

    const errors = response?.data?.cartLinesUpdate?.userErrors || [];
    if (errors.length) {
      console.warn('cartLinesUpdate userErrors', errors);
      return;
    }

    if (response?.data?.cartLinesUpdate?.cart?.id) {
      console.log('cdebug successful updating of selling plan');
      await this.refreshCart();
    }

  } catch (err) {
    console.error('Subscription update error', err);
  } finally {
    this.toggleCartDrawerLoader(false);
  }
}


  async getCartToken() {
    let response;
    let responseStatus;

    try {
      response = await fetch(window.Shopify.routes.root + `cart.js`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }).then((res) => {
        // console.log("In cart-drawer getCartToken() Response: ", res);
        responseStatus = res.status;
        return res.json();
      });
    } catch (e) {
      console.error("cdebug error", e);
    }

    if (responseStatus === 200) {
      this.cartToken = response?.token;
    }

    console.log("cdebug cart token", this.cartToken);
  }

  async getCartLineIds() {
    let response;

    const cartQuery = `query getCartGQL($id: ID!) {
      cart(id: $id) {
        id
        lines(first: 250) {
          edges {
            node {
              id
              quantity
              sellingPlanAllocation {
                sellingPlan {
                  id
                  name
                }
              }
              merchandise {
                ... on ProductVariant {
                  id
                  product { title }
                  title
                }
              }
              attributes {
                key
                value
              }
            }
          }
        }
      }
    }`;
    console.log("In getCartLineIds() cdebug cart token", this.cartToken);
    try {
      response = await window.storeFrontAPIClient.request(cartQuery, {
        variables: { id: `gid://shopify/Cart/${this.cartToken}` },
      });
      console.log("In cart-drawer getCartLineIds() Response: ", response);
    } catch (e) {
      console.error("cdebug error", e);
      return;
    }

    console.log("cdebug cart gql", response);

    if (Array.isArray(response?.data?.cart?.lines?.edges)) {
      this.formatAndSaveLineIds(response.data.cart.lines.edges);
      this.printLineIdsToDOM();
    }
  }
  syncDeliveryFrequencyUI() {
  const mealItems = Array.from(this.querySelectorAll('.cart-item.--item-is-meal'));

  mealItems.forEach(item => {
    const lineId = item.getAttribute('data-line-id');
    const line = this.lineItems.find(l => l.id === lineId);
    if (!line) return;

    const planContainer = item.querySelector('.selling-plan-options');
    if (!planContainer) return;

    const oneWeekId = planContainer.getAttribute('data-selling-plan-1-week-id');
    const twoWeekId = planContainer.getAttribute('data-selling-plan-2-weeks-id');

    const radios = item.querySelectorAll('[data-delivery-option]');
    radios.forEach(radio => radio.classList.remove('is-active'));

    if (!line.sellingPlanId) {
      item.querySelector('[data-delivery-option="one-off"]')?.classList.add('is-active');
      return;
    }

    if (line.sellingPlanId === oneWeekId) {
      item.querySelector('[data-delivery-option="1-week"]')?.classList.add('is-active');
    }

    if (line.sellingPlanId === twoWeekId) {
      item.querySelector('[data-delivery-option="2-weeks"]')?.classList.add('is-active');
    }
  });
}


  async refreshCart() {
    let response;
    let responseStatus;

    try {
      response = await fetch(window.Shopify.routes.root + `?sections=cart-drawer`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }).then((res) => {
        responseStatus = res.status;
        return res.json();
      });
    } catch (e) {
      console.error("cdebug error", e);
      return;
    }

    if (responseStatus === 200) {
      [
        {
          id: "cart-drawer",
          selector: "#CartDrawer",
        },
      ].forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;

        sectionElement.innerHTML = this.getSectionInnerHTML(response[section.id], section.selector);
      });
    }

    await this.getCartLineIds();
    this.bindUIElements();
    this.syncDeliveryFrequencyUI();

    console.log(
      "cdebug cart response",
      new DOMParser().parseFromString(response["cart-drawer"], "text/html").querySelector(".cart-items")
    );
  }

  printLineIdsToDOM() {
    const lineItemsDOM = Array.from(this.querySelectorAll(".cart-item"));

    lineItemsDOM.forEach((lineItemDOM) => {
      const lineItemDOMVariant = lineItemDOM.getAttribute("data-line-variant-id");
      console.log("LineItemDOMVariant: ", lineItemDOMVariant);
      console.log("This LineItems: ", this.lineItems);
      const lineItem = this.lineItems.find((li) => li.variantId == lineItemDOMVariant);

      if (lineItem) {
        lineItemDOM.setAttribute("data-line-id", lineItem.id);
      }
    });
  }

  formatAndSaveLineIds(lineItems) {
    this.lineItems = lineItems.map((item) => {
      const lineItem = item.node;
      const variantId = lineItem?.merchandise?.id?.replace("gid://shopify/ProductVariant/", "");

      return {
        id: lineItem.id,
        variantId,
        sellingPlanId: lineItem.sellingPlanAllocation?.sellingPlan?.id || null,
        sellingPlanName: lineItem.sellingPlanAllocation?.sellingPlan?.name || null,
      };
    });

    console.log("cdebug lineitems", this.lineItems);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");

    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
      addCartNote && addCartNote();
    });

    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
        addCartNote && addCartNote();
      }
    });
  }

  setHeaderCartIconsAccessibility() {
    const cartLinks = Array.from(document.querySelectorAll(".cart-icon-bubble"));

    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");

      cartLink.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(cartLink);
        addCartNote && addCartNote();
      });

      cartLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open(cartLink);
          addCartNote && addCartNote();
        }
      });
    });

    window.initCollectionProgess && window.initCollectionProgess();
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");

        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling?.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState, showToastInstead, source) {
    let quantity = parsedState.quantity || parsedState?.["item_count"];

    if (quantity == 0) {
      this?.classList.add("is-empty");
      this.querySelector(".drawer__inner")?.classList.add("is-empty");
    } else {
      this?.classList.remove("is-empty");
      this.querySelector(".drawer__inner")?.classList.remove("is-empty");
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    const cartLinks = Array.from(document.querySelectorAll(".cart-icon-bubble"));
    cartLinks.forEach((cartLink) => {
      cartLink.innerHTML = document.querySelector("#cart-icon-bubble").innerHTML;
    });

    window.initCollectionProgess && window.initCollectionProgess();

    const collectionProgressBar = document.querySelector(".collection-progress-bar");

    if (quantity > 0) {
      collectionProgressBar && collectionProgressBar.classList.add("--active");
      this.getCartToken();
      this.getCartLineIds();
    } else {
      collectionProgressBar && collectionProgressBar.classList.remove("--active");
    }

    toggleProgressBarVisibilityOnUpdate();

    if (source != "cre-quantity-sync") {
      if (showToastInstead && typeof Toastify !== "undefined") {
        const toastMessage = window?.variantStrings?.addToCartToast?.replace("[product-name]", parsedState.title);

        const toastConfig = {
          text: toastMessage,
          duration: 5000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "left",
          stopOnFocus: true,
          style: { background: "rgba(var(--color-button),var(--alpha-button-background))" },
          onClick: function () {},
        };

        if (window.prevToast && window.prevToast.hideToast) window.prevToast.hideToast();
        window.prevToast = Toastify(toastConfig);
        window.prevToast.showToast();
      } else {
        document.querySelector("cart-drawer")?.open();
      }
    }

    this.bindUIElements();
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector)?.innerHTML || "";
  }

  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble" },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

/* ===== Open cart drawer from URL ?openCartDrawer=true ===== */
function openCartDrawerFromURL() {
  const params = new URLSearchParams(window.location.search);
  const shouldOpen = params.get("openCartDrawer");

  if (!shouldOpen) return;

  const attemptOpen = () => {
    const drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      return true;
    }
    return false;
  };

  if (attemptOpen()) return;

  let attempts = 0;
  const interval = setInterval(() => {
    attempts += 1;
    if (attemptOpen() || attempts > 20) clearInterval(interval);
  }, 100);
}

document.addEventListener("DOMContentLoaded", () => {
  openCartDrawerFromURL();
});

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
      { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class ClearCart extends HTMLElement {
  constructor() {
    super();
    this.clearButton = this.querySelector("button");
    if (this.clearButton) {
      this.clearButton.addEventListener("click", this.onClickClearCart.bind(this));
    }
  }

  onClickClearCart(event) {
    event.preventDefault();

    const url = "/cart/clear.js";
    const data = {
      sections: document
        .querySelector("cart-drawer-items")
        .getSectionsToRender()
        .map((section) => section.section),
      sections_url: window.location.pathname,
    };

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        document.querySelector("cart-drawer-items").getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = document
            .querySelector("cart-drawer-items")
            .getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });

        const collectionProgressBar = document.querySelector(".collection-progress-bar");
        if (collectionProgressBar) collectionProgressBar.classList.remove("--active");
        toggleProgressBarVisibilityOnUpdate();

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "clear-cart",
          productVariantId: null,
          sectionUpdates: [],
          incomingQty: 0,
        });

        if (document.querySelector("cre-price-sync")?.syncPriceToProduct) {
          document.querySelector("cre-price-sync").syncPriceToProduct();
        }

        document.querySelector("cart-drawer")?.classList.add("is-empty");

        const quantityInputs = document.querySelectorAll("quantity-input:not(cart-drawer .quantity-input)");
        const visibleQuantityInputs = Array.from(quantityInputs).filter((input) => !input.classList.contains("hidden"));
        if (visibleQuantityInputs.length === 0) return;

        visibleQuantityInputs.forEach((each) => {
          const removedProductVariantId = each.dataset.vid;
          const productremove = new CustomEvent(`remove-product--${removedProductVariantId}`, {
            detail: { quantity: 0 },
          });
          document.dispatchEvent(productremove);
        });

        const cartLinks = Array.from(document.querySelectorAll(".cart-icon-bubble"));
        cartLinks.forEach((cartLink) => {
          cartLink.innerHTML = document.querySelector("#cart-icon-bubble").innerHTML;
        });

        window.initCollectionProgess && window.initCollectionProgess();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("clear-cart", ClearCart);

function toggleProgressBarVisibilityOnUpdate() {
  const mealItems = Array.from(document.querySelectorAll(".cart-item.--item-is-meal"));
  const cartDrawerFooter = document.querySelector(".cart-drawer__footer");
  const collectionBarWrapper = document.querySelector(".collection-bar-wrapper");

  if (mealItems.length > 0) {
    cartDrawerFooter && cartDrawerFooter.classList.add("--active");
    collectionBarWrapper && collectionBarWrapper.classList.add("--active");
  } else {
    cartDrawerFooter && cartDrawerFooter.classList.remove("--active");
    collectionBarWrapper && collectionBarWrapper.classList.remove("--active");
  }
}